"use client";

import { useEffect } from "react";
import { useSearchParams, useRouter } from "next/navigation";
import { toast } from "sonner";
import { getToastFromParams } from "@/lib/toast-client";

export function ToastHandler() {
  const searchParams = useSearchParams();
  const router = useRouter();

  useEffect(() => {
    const toastData = getToastFromParams(searchParams);
    
    if (toastData) {
      // Show toast based on type
      switch (toastData.type) {
        case "success":
          toast.success(toastData.title, {
            description: toastData.description,
          });
          break;
        case "error":
          toast.error(toastData.title, {
            description: toastData.description,
          });
          break;
        case "warning":
          toast.warning(toastData.title, {
            description: toastData.description,
          });
          break;
        case "info":
          toast.info(toastData.title, {
            description: toastData.description,
          });
          break;
      }

      // Clean URL params after showing toast
      const url = new URL(window.location.href);
      url.searchParams.delete("toast_type");
      url.searchParams.delete("toast_title");
      url.searchParams.delete("toast_description");
      
      router.replace(url.pathname + (url.search ? `?${url.searchParams.toString()}` : ""), {
        scroll: false,
      });
    }
  }, [searchParams, router]);

  return null;
}
